











































































import toCurrency from '@/filters/to-currency'
import toDate from '@/filters/to-date'
import toDateTime from '@/filters/to-date-time'
import toErrorMessage from '@/filters/to-error-message'
import toTaxStatusColor from '@/filters/to-tax-status-color'
import toTaxStatusTextColor from '@/filters/to-tax-status-text-color'
import Translation from '@/mixins/Translation'
import InlineThTd from '@/components/InlineThTd.vue'
import {Component, Mixins, Prop} from 'vue-property-decorator'
@Component({
  components: {
    InlineThTd,
  },
  filters: {
    toCurrency,
    toDate(value?: number | null | 'indefinite', indefiniteText?: any) {
      if(value === 'indefinite' || value === null) {
        return indefiniteText
      } else if(!value) {
        return ''
      }
      return toDate(value)
    },
    toDateTime(value?: number | null | 'indefinite', indefiniteText?: any) {
      if(value === 'indefinite' || value === null) {
        return indefiniteText
      } else if(!value) {
        return ''
      }
      return toDateTime(value)
    },
    toErrorMessage,
  },
  methods: {
    toCurrency,
    toTaxStatusColor,
    toTaxStatusTextColor,
  },
})
export default class TaxInfo extends Mixins(Translation) {
  @Prop({default: null, type: Object}) tax: object | null
  @Prop({default: true, type: Boolean}) loading: boolean
}
